// Async filtering script
$(document).ready(function() {
    window.efScripts.onVariantsFilter.push(fetchTeachersFilter)

    // Fetch initial teachers filer
    fetchTeachersFilter();
});

function bindClickHandler() {
    $('#teacher-options :checkbox').on('click', function() {
        const value = this.value;

        if(this.checked) {
            window.efScripts.variantFilters.teachers = [...window.efScripts.variantFilters.teachers, value]
        } else {
            window.efScripts.variantFilters.teachers = window.efScripts.variantFilters.teachers.filter(function(item) {
                return item !== value;
            });
        }

        window.efScripts.applyVariantFilters();
    });
}

function fetchTeachersFilter(){
    jQuery.ajax({
        type    : 'POST',
        url     : efScripts.ajaxUrl,
        data    : {
            'action' : 'eduframe_get_teachers_filter',
            ...window.efScripts.variantFilters
        },
        timeout: 5000,
        beforeSend: function(){
            $('#location-options :checkbox').unbind('click');
        },
        success: function(response) {
            jQuery('#teachers-filter').html(response);
            bindClickHandler();
        },
        error: function(xhr, textStatus, errorThrown){
            jQuery('#teachers-filter').html(xhr.responseText);
        }
    });
}